import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { map, sumBy, filter } from 'lodash';
import MoneyDisplay from '../money-display';
import NumberDisplay from '../number-display';


class StatusRowComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      totalAmount: 0,
      totalCount: 0,
    };
    this.calculate = this.calculate.bind(this);
  }


  componentWillMount() {
    this.props.api.addEventListener('modelUpdated', this.calculate);
  }
  componentDidMount() {
    this.calculate();
  }
  componentWillUnmount() {
    this.props.api.removeEventListener('modelUpdated', this.calculate);
  }

  calculate() {
    const { context } = this.props;
    const field = context ? context.footerSumField || 'amount' : 'amount';
    const allRows = map(filter(this.props.api.getModel().rowsToDisplay, { level: 0 }), 'data');
    const totalCount = allRows.length;
    const totalAmount = sumBy(allRows, field);
    this.setState({ totalCount, totalAmount });
  }

  render() {
    const { totalCount, totalAmount } = this.state;
    const { context } = this.props;
    const statUnit = context ? context.statUnit || 'Opportunities' : 'Opportunities';
    return (
      <div className="ag-status-panel">
        <div className="ag-name-value">
          <span>Total {statUnit}</span>: <span className="ag-name-value-value"><NumberDisplay value={totalCount} precision={0} /></span>
        </div>
        <div className="ag-name-value">&nbsp;&nbsp;|&nbsp;&nbsp;</div>
        <div className="ag-name-value">
          <span>Total Amount</span>: <span className="ag-name-value-value"><MoneyDisplay value={totalAmount} precision={2} abbreviated /></span>
        </div>
      </div>
    );
  }
}

StatusRowComponent.propTypes = {
  api: PropTypes.shape({
    getModel: PropTypes.func,
    addEventListener: PropTypes.func,
    removeEventListener: PropTypes.func,
  }).isRequired,
  context: PropTypes.shape({
    statUnit: PropTypes.string,
  }),
};
StatusRowComponent.defaultProps = {
  context: {
    statUnit: 'Opportunities',
  },
};
export default StatusRowComponent;
